import React from "react";

const MobileWidgets = () => {
  return (
    <div className="offcanvas-widget-area">
      <div className="off-canvas-contact-widget">
        <div className="header-contact-info">
          <ul className="header-contact-info__list">
            <li>
              <i className="fa fa-phone"></i> +90 537 541 8777
            </li>
            <li>
              <i className="fa fa-envelope"></i>{" "}
              <a href="mailto:destek@minyatursepeti.com">
                destek@minyatursepeti.com
              </a>
            </li>
          </ul>
        </div>
      </div>
      {/*Off Canvas Widget Social Start*/}
      <div className="off-canvas-widget-social">
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.instagram.com/minyatursepeti"
          title="Instagram"
        >
          <i className="fa fa-instagram"></i>
        </a>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.facebook.com/minyatursepeti"
          title="Facebook"
        >
          <i className="fa fa-facebook"></i>
        </a>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.etsy.com/shop/MinyaturSepeti"
          title="Etsy"
        >
          Etsy
        </a>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://pin.it/9rhdE2Z9j"
          title="Pinterest"
        >
          <i className="fa fa-pinterest"></i>
        </a>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.youtube.com/@minyatursepeti7219"
          title="Youtube"
        >
          <i className="fa fa-youtube"></i>
        </a>
      </div>
      {/*Off Canvas Widget Social End*/}
    </div>
  );
};

export default MobileWidgets;
